import {MutableRefObject, useEffect, useRef} from 'react';
import {noop} from '@priority-software/priority-style-react';
import {setDynamicColumnGap} from '../utils';

export const useUpdateGridGaps = (gridRef: MutableRefObject<HTMLDivElement>) => {
    const wrapWidthRef = useRef(0);

    useEffect(() => {
        if (!gridRef.current) return noop;

        // Initialize wrapWidthRef with the actual width once the element is available
        wrapWidthRef.current = gridRef.current.offsetWidth;

        const updateColumnGap = () => {
            if (!gridRef.current) return;

            if (wrapWidthRef.current !== gridRef.current.offsetWidth) {
                wrapWidthRef.current = gridRef.current.offsetWidth;
                setDynamicColumnGap(gridRef.current, 140);
            }
        };

        const observer = new ResizeObserver(updateColumnGap);
        observer.observe(gridRef.current);

        return () => observer.disconnect();
    }, []);
};
